var GoogleGeoCoderResponse = /** @class */ (function () {
    function GoogleGeoCoderResponse(state, name) {
        this.state = '';
        this.name = '';
        this.data = new Map();
        this.state = state;
        this.name = name;
    }
    GoogleGeoCoderResponse.prototype.getName = function () {
        return this.name;
    };
    GoogleGeoCoderResponse.prototype.isOk = function () {
        return this.state === 'OK';
    };
    GoogleGeoCoderResponse.prototype.getState = function () {
        return this.state;
    };
    GoogleGeoCoderResponse.prototype.setState = function (state) {
        this.state = state;
    };
    GoogleGeoCoderResponse.prototype.addCity = function (code, city) {
        this.data.set(code, city);
    };
    GoogleGeoCoderResponse.prototype.getData = function () {
        return this.data;
    };
    return GoogleGeoCoderResponse;
}());
export { GoogleGeoCoderResponse };
export default GoogleGeoCoderResponse;
